export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/vue-svg-inline-loader/src/index.js!./SocialSharingLink.vue?vue&type=template&id=2fac0b1b&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/components/SocialSharingLink.vue?vue&type=template&id=2fac0b1b&scoped=true
// module id = 155
// module chunks = 0